import { MailActions } from '@web-common/state/createStore';
import { edmMailHelper, getIn18Text, inWindow, } from 'api';
import { getMainAccount } from '@web-mail/util';
import { reduxMessage } from '@web-common/utils/redux_utils';
import { getIsSearchingMailByState } from '@web-mail/state/customize';
import CustomerIcon from '@web-common/components/UI/Icons/svgs/edm/CustomerIcon';
import CustomerContactIcon from '@web-common/components/UI/Icons/svgs/edm/CustomerContactIcon';
import { tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import { doGetCustomersByIds } from '@web-common/state/reducer/contactReducer';
import { FLOLDER, MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT } from '@web-mail/common/constant';
import { systemApi } from '@web-common/utils/contact_util';
export var CustomerType;
(function (CustomerType) {
    CustomerType["MY_CUSTOMER"] = "MY_CUSTOMER";
    CustomerType["ALL_CUSTOMER"] = "ALL_CUSTOMER";
})(CustomerType || (CustomerType = {}));
export const getCustomerSliceIdByType = (type) => {
    return type === CustomerType.MY_CUSTOMER ? tabId.readCustomer : tabId.readAllCustomer;
};
export const getCustomerTypeBySliceId = (id) => {
    return id === tabId.readCustomer ? CustomerType.MY_CUSTOMER : CustomerType.ALL_CUSTOMER;
};
export const sliceStateCheck = (state, sliceId, edmMailKey) => sliceId && state[edmMailKey] && state[edmMailKey][sliceId];
export const getCustomerSlice = (state, sliceId) => sliceId && state['customer'] && state['customer'][sliceId];
export const getSubordinateSlice = (state, sliceId) => sliceId && state['subordinate'] && state['subordinate'][sliceId];
const _getNodeDataByKey = (data, key, _parent) => {
    let current;
    let parent;
    data.forEach(item => {
        if (!current) {
            if (item.key === key) {
                current = item;
                parent = _parent;
            }
            else if (item.children) {
                const res = _getNodeDataByKey(item.children, key, item);
                current = res.current;
                parent = res.parent;
            }
        }
    });
    return {
        current,
        parent,
    };
};
export const getNodeDataByKey = (data, key) => {
    const res = _getNodeDataByKey(data, key);
    return res.current;
};
export const getNodeParentDataByKey = (data, key) => {
    const res = _getNodeDataByKey(data, key);
    return res.parent;
};
export const getNodeParentsIdByKey = (data, key) => {
    var _a;
    let rootId, parentId, originParentId;
    const { current, parent } = _getNodeDataByKey(data, key);
    if ((parent === null || parent === void 0 ? void 0 : parent.nodeType) === 'group' && (current === null || current === void 0 ? void 0 : current.nodeType) === 'customer') {
        rootId = parent.key;
        parentId = current.key;
        originParentId = current.originId;
    }
    else if ((parent === null || parent === void 0 ? void 0 : parent.nodeType) === 'customer' && (current === null || current === void 0 ? void 0 : current.nodeType) === 'contact') {
        rootId = (_a = getNodeParentDataByKey(data, parent.key)) === null || _a === void 0 ? void 0 : _a.key;
        parentId = parent.key;
        originParentId = parent.originId;
    }
    else if ((current === null || current === void 0 ? void 0 : current.nodeType) === 'group' && !parent) {
        rootId = current.key;
    }
    else if ((current === null || current === void 0 ? void 0 : current.nodeType) === 'customer' && !parent) {
        parentId = current.key;
        originParentId = current.originId;
    }
    return {
        rootId,
        parentId,
        originParentId,
    };
};
export const getToListAndUpdateTree = async (isSearching, dispatch, state, sliceId, type) => {
    const isSliceExist = sliceStateCheck(state, sliceId, type);
    if (isSliceExist) {
        let to = [];
        const customerState = state[type][sliceId];
        const treeList = isSearching ? customerState.searchTreeList : customerState.customerTreeList;
        const key = isSearching ? customerState.selectedSearchKeys.id : customerState.selectedKeys.id;
        const node = getNodeDataByKey(treeList, key);
        let children = node === null || node === void 0 ? void 0 : node.children;
        if (children === null || children === void 0 ? void 0 : children.length) {
            children.forEach(item => {
                if (item.email) {
                    to.push(item.email);
                }
            });
        }
        if (isSearching) {
            dispatch(MailActions.doUpdateSelectedSearchContacts_cm({ data: { list: to }, sliceId }));
        }
        else {
            dispatch(MailActions.doUpdateSelectedContacts_cm({ data: { list: to }, sliceId }));
        }
        return to;
    }
    return [];
};
export const getCustomerContacts = async (customerId, treeList) => {
    const customerDetail = await doGetCustomersByIds([customerId]);
    if (!(customerDetail === null || customerDetail === void 0 ? void 0 : customerDetail.length)) {
        console.warn('getCustomerContacts error no customerDetail');
        return {
            treeList: treeList,
            contactEmails: [],
            updatedTreeData: undefined,
        };
    }
    const { contactList, managerList } = customerDetail[0];
    console.log('[load customer contact]', customerDetail);
    const treeChildData = formatCustomerTreeChild(contactList, managerList);
    const newTreeList = treeList.map((v) => {
        if (v.key === customerId) {
            return Object.assign(Object.assign({}, v), { children: treeChildData || [], isLeaf: contactList.length === 0, managerList });
        }
        return v;
    });
    return {
        treeList: newTreeList,
        contactEmails: contactList.map(v => v.email),
        updatedTreeData: newTreeList.find(v => v.key === customerId),
    };
};
export const getLastMailInSlice = (state, startIndex = 0, sliceId, type) => {
    if (startIndex === 0) {
        return null;
    }
    const { mailEntities } = state;
    const isSearching = getIsSearchingMailByState(state, sliceId, type);
    const list = isSearching && type === 'customer' ? state[type][sliceId].searchList : state[type][sliceId].mailDataList;
    const lastMailId = list[startIndex - 1];
    if (!lastMailId) {
        return null;
    }
    return mailEntities[lastMailId] || null;
};
export const getEdmMailListReq = (state, params, sliceId, toList) => {
    var _a;
    const { startIndex = 0, type } = params;
    const _state = sliceStateCheck(state, sliceId, type);
    if (!_state) {
        throw new Error('Slice not Exist');
    }
    const isSearching = getIsSearchingMailByState(state, sliceId, type);
    const lastMail = getLastMailInSlice(state, startIndex, sliceId, type);
    const endDate = lastMail ? lastMail.entry.sendTime : '';
    if (type === 'customer') {
        const customerState = _state;
        const filterState = isSearching ? customerState.searchListStateTab : customerState.mailListStateTab;
        const attrQuery = [];
        const to = toList || (isSearching ? state[type][sliceId].selectedSearchContacts.list : state[type][sliceId].selectedContacts.list);
        const subMenuState = isSearching ? state[type][sliceId].mailListTabMenuSearch : state[type][sliceId].mailListTabMenu;
        const endMid = lastMail ? lastMail.id : '';
        const managerList = ((_a = state[type][sliceId].selectedKeys) === null || _a === void 0 ? void 0 : _a.managerList) || [];
        if (filterState !== 'COLLEAGUE') {
            attrQuery.push({ to });
        }
        if (managerList.length) {
            if (filterState === 'COLLEAGUE') {
                managerList.forEach(item => {
                    if (!!item.managerAccount && item.managerAccount !== getMainAccount()) {
                        attrQuery.push({
                            from: item.managerAccount,
                            to,
                        });
                    }
                });
            }
            if (filterState === 'ALL') {
                managerList.forEach(item => {
                    attrQuery.push({
                        from: item.managerAccount,
                        to,
                    });
                });
            }
        }
        let attrQueryFilter;
        if (filterState == 'ME') {
            if (subMenuState === 'Send') {
                attrQueryFilter = { type: 'send' };
            }
            else if (subMenuState === 'Receive') {
                attrQueryFilter = { type: 'receive' };
            }
        }
        return {
            index: startIndex,
            returnModel: true,
            returnTag: true,
            checkType: 'checkCustomerMail',
            count: endDate ? 100 : 30,
            endDate,
            endMid,
            attrQuery,
            attrQueryFilter: attrQueryFilter,
            noContactRace: !!params.noContactRace,
        };
    }
    if (type === 'subordinate') {
        const subordinateState = _state;
        const { mailListStateTab: filterState, mailDataList } = subordinateState;
        const { subEmails, subEmails2Account } = subordinateState.selectedFolder.relationEmailList.reduce((res, item) => {
            if (item.email && item.accountId) {
                res.subEmails.push(item.email);
                res.subEmails2Account[item.email] = item.accountId;
            }
            return res;
        }, {
            subEmails: [],
            subEmails2Account: {},
        });
        const param = {
            index: startIndex,
            returnModel: true,
            returnTag: true,
            checkType: 'checkSubordinateMail',
            count: endDate ? 100 : 30,
            endDate,
            attrQuery: {},
            noContactRace: params.noContactRace,
            subordinateId: subordinateState.selectedFolder.subordinateId,
            subEmails,
            subEmails2Account,
        };
        const ids = subordinateState.selectedFolder.ids.map(fid => +fid);
        if (ids.length === 1) {
            param.id = ids[0];
        }
        else if (ids.length > 1) {
            if (filterState === 'SEND') {
                param.id = ids.find(id => id === FLOLDER.SENT) || FLOLDER.SENT;
            }
            else if (filterState === 'RECEIVE') {
                param.ids = ids.filter(id => id !== FLOLDER.SENT);
            }
            else {
                param.ids = ids;
            }
        }
        if ((param === null || param === void 0 ? void 0 : param.ids) && !!(param === null || param === void 0 ? void 0 : param.ids.length)) {
            param.ids = param.ids.filter(edmMailHelper.filterEdmFid);
        }
        if (mailDataList.length && [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].some(fid => fid === param.id)) {
            param.startId = mailDataList[mailDataList.length - 1];
        }
        if (mailDataList.length && (param.subordinateId === 'allSubordinate' || param.subordinateId === 'allColleague')) {
            param.startId = mailDataList[mailDataList.length - 1];
        }
        return param;
    }
    return {};
};
export class SyncTimerFactory {
    constructor(req, errMessage = '') {
        this.timer = 0;
        this.errMessage = '';
        this.request = req;
        this.errMessage = errMessage;
    }
    startSyncRace(cb) {
        if (inWindow()) {
            this.cancelSyncRace();
            this.timer = window.setTimeout(() => {
                cb && cb();
                if (this.errMessage) {
                    reduxMessage.error({ content: this.errMessage });
                }
            }, 3 * 60 * 1000);
        }
        return this.request().catch(() => {
            console.log('11111111');
            cb && cb();
            this.cancelSyncRace();
        });
    }
    cancelSyncRace() {
        if (inWindow()) {
            if (this.timer) {
                window.clearTimeout(this.timer);
                this.timer = 0;
            }
        }
    }
}
export const createCustomerGroupALL = (parentId, hasChildren, count) => {
    return {
        title: getIn18Text('QUANBU'),
        key: createGroupALLKey(parentId),
        originId: parentId,
        icon: null,
        isLeaf: !hasChildren,
        nodeType: 'group',
        nodeData: {
            id: parentId,
            count,
        },
    };
};
export const formatCustomerGroup2TreeData = (data, parentId) => {
    const list = [];
    let hasChildren = false;
    data.forEach(item => {
        if (item.hasChildren) {
            hasChildren = true;
        }
        list.push({
            title: item.name,
            key: item.id,
            icon: null,
            isLeaf: !item.hasChildren,
            nodeData: item,
            originId: item.id,
            nodeType: parentId == '' ? 'root' : 'group',
        });
    });
    if (list.length > 0 && parentId && parentId !== MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT) {
        list.unshift(createCustomerGroupALL(parentId, hasChildren));
    }
    return list;
};
export const formatCustomer2TreeData = (item, parentId) => {
    return {
        title: item.orgName,
        key: createTreeKey(item.id, parentId),
        icon: CustomerIcon(),
        isLeaf: false,
        nodeData: item,
        nodeType: 'customer',
        originId: item.id,
        managerList: item.managerList,
    };
};
export const formatCustomerContact2TreeData = (item, parentId, managerList) => {
    return {
        title: item.name || item.email,
        key: createTreeKey(item.id, parentId),
        icon: CustomerContactIcon(),
        email: item.email,
        isLeaf: true,
        nodeType: 'contact',
        originId: item.id,
        managerList,
    };
};
export const formatCustomerTreeData = (inputs) => {
    return inputs.map(data => {
        const { contacts, orgName, id, managerList } = data;
        const children = Array.isArray(contacts) ? formatCustomerTreeChild(contacts, managerList) : undefined;
        return {
            title: orgName,
            key: id,
            icon: CustomerIcon(),
            isLeaf: false,
            nodeData: data,
            children,
            managerList,
        };
    });
};
export const transCustomerBaseInfo2CustomerTreeData = (inputs) => {
    return inputs.map(data => {
        const { customerId, customerName, customerCreateTime, managerList } = data;
        const nodeData = {
            orgName: customerName,
            id: customerId,
            lastMailTime: customerCreateTime,
            contacts: [],
            managerList,
        };
        return {
            title: customerName,
            key: customerId,
            icon: CustomerIcon(),
            isLeaf: false,
            nodeType: 'customer',
            nodeData,
            managerList,
        };
    });
};
export const formatCustomerTreeChild = (contacts, managerList) => {
    return Array.isArray(contacts) && contacts.length > 0
        ? contacts.map(v => ({
            title: v.name || v.email,
            key: v.id,
            icon: CustomerContactIcon(),
            nodeType: 'contact',
            email: v.email,
            isLeaf: true,
            managerList: managerList,
        }))
        : [];
};
export const formatSubordinateTreeChild = (contacts, managerList) => {
    return Array.isArray(contacts) && contacts.length > 0
        ? contacts.map(v => ({
            title: v.contactName || v.accountName,
            key: v.accountId,
            icon: CustomerContactIcon(),
            email: v.accountName,
            isLeaf: true,
            managerList: managerList,
        }))
        : [];
};
export const genEdmMailTabId = (type) => {
    return `${type}_${Date.now()}`;
};
export const genEdmMilTabModel = ({ type, title, from, id, extra, }) => {
    return {
        id: id || genEdmMailTabId(type),
        title: title || '客户邮件' + id,
        type: tabType[type],
        closeable: true,
        isActive: true,
        extra: Object.assign(Object.assign({}, extra), { from }),
    };
};
export const getCustomerGroupRequestParams = (state, level, id) => {
    if (!id || !state) {
        return undefined;
    }
    if (id) {
        const { isAll, key } = parseGroupALLKey(id);
        if (isAll) {
            level = 1;
            id = key;
        }
    }
    if (level === 1) {
        const res = state.customerGroupList.find(item => String(item.id) === id);
        if (!res) {
            return undefined;
        }
        return res.requestParams;
    }
    if (level === 2) {
        const res = state.customerTreeList.find(item => String(item.key) === id);
        if (!res) {
            return undefined;
        }
        return res.nodeData.requestParams;
    }
    return undefined;
};
export const insertCustomer2TreeData = (params) => {
    const { level, treeData, data, refresh, parentId, hasMore, page } = params;
    const list = [];
    data.forEach(item => {
        list.push(formatCustomer2TreeData(item, parentId));
    });
    if (level === 1) {
        if (refresh) {
            return list;
        }
        else {
            return [...treeData, ...list];
        }
    }
    else {
        treeData.forEach(group => {
            if (group.key === parentId) {
                const children = refresh ? list : [...(group.children || []), ...list];
                if (children.length === 0) {
                    group.isLeaf = true;
                }
                group.children = children;
                group.hasMore = hasMore;
                group.page = page;
            }
        });
        return [...treeData];
    }
};
export const insertGroup2TreeData = (params) => {
    const { level, treeData, data, refresh, parentId, hasMore, page } = params;
    const list = formatCustomerGroup2TreeData(data, parentId);
    if (level === 1) {
        if (refresh) {
            return list;
        }
        else {
            return [...treeData, ...list];
        }
    }
    else {
        treeData.forEach(group => {
            if (group.key === parentId) {
                const children = (refresh ? list : [...(group.children || []), ...list]).map(item => (Object.assign(Object.assign({}, item), { isLeaf: true })));
                if (children.length === 0) {
                    group.isLeaf = true;
                }
                group.children = children;
                group.hasMore = hasMore;
                group.page = page;
            }
        });
        return [...treeData];
    }
};
export const inserCustomerContact2TreeData = (params) => {
    const { treeData, data = [], refresh, parentId, hasMore, page } = params;
    treeData.forEach(group => {
        var _a;
        if (group.key === parentId) {
            const list = data.map(contact => formatCustomerContact2TreeData(contact, parentId, group.managerList));
            const children = refresh ? list : [...(group.children || []), ...list];
            if (children.length === 0) {
                group.isLeaf = true;
            }
            group.children = children;
            group.hasMore = hasMore;
            group.page = page;
        }
        else {
            (_a = group.children) === null || _a === void 0 ? void 0 : _a.forEach(item => {
                if (item.key === parentId) {
                    const list = data.map(contact => formatCustomerContact2TreeData(contact, parentId, item.managerList));
                    const children = refresh ? list : [...(item.children || []), ...list];
                    if (children.length === 0) {
                        item.isLeaf = true;
                    }
                    item.children = children;
                    item.hasMore = hasMore;
                    item.page = page;
                }
            });
        }
    });
    return [...treeData];
};
export const createTreeKey = (key, parentKey) => {
    return parentKey + '_' + key;
};
export const parseTreeKey = (key) => {
    if (key.includes('_')) {
        const list = key.split('_');
        return list[list.length - 1];
    }
    return key;
};
const createGroupALLKey = (key) => {
    return key + '_ALL';
};
export const parseGroupALLKey = (key) => {
    if (key.includes('_ALL')) {
        return {
            key: key.split('_ALL')[0],
            isAll: true,
        };
    }
    return { key, isAll: false };
};
export const formatSubordinateFolder2TreeData = (params) => {
    const { list, ids, colleagueAccountId, accountId, relationEmailList } = params;
    return list.map(model => ({
        title: model.entry.mailBoxName,
        key: `folder@@${colleagueAccountId}@@${accountId}@@${model.mailBoxId}`,
        isLeaf: model.childrenCount === 0,
        nodeData: model,
        ids: model.mailBoxId === 'ALL_FOLDER' ? ids : [model.mailBoxId],
        originId: model.mailBoxId,
        relationEmailList,
        nodeType: 'folder',
        colleagueAccountId,
        children: formatSubordinateFolder2TreeData({
            list: model.children || [],
            ids,
            colleagueAccountId,
            relationEmailList,
            accountId,
        }),
    }));
};
export const insertSubordinateFolder2TreeData = (params) => {
    const { treeData, data, relationList, colleagueAccountId } = params;
    if (relationList.length) {
        const defaultList = createDefaultMegerFolderList(colleagueAccountId, relationList);
        const list = [];
        relationList.forEach(relation => {
            const email = relation.email;
            let item;
            if (data[email]) {
                item = data[email];
            }
            else if (relation.accountId === colleagueAccountId) {
                item = data['main'];
            }
            if (item) {
                const accountRelationEmail = formatSubordinateRelationEmail2TreeData(colleagueAccountId, relation);
                const { mailBoxModel, ids: folderIds } = item;
                accountRelationEmail.children = formatSubordinateFolder2TreeData({
                    list: mailBoxModel,
                    ids: folderIds,
                    relationEmailList: [relation],
                    colleagueAccountId,
                    accountId: relation.accountId,
                });
                list.push(accountRelationEmail);
            }
        });
        treeData.forEach(item => {
            if (item.originId === colleagueAccountId) {
                if (list.length === 0) {
                    item.isLeaf = true;
                }
                else if (list.length === 1 && list[0].originId === colleagueAccountId) {
                    item.children = list[0].children;
                }
                else {
                    item.children = [...defaultList, ...list];
                }
            }
        });
        return [...treeData];
    }
    return treeData;
};
export const formatColleague2TreeData = (params) => {
    var _a, _b;
    const { colleague, data, relationList, colleagueAccountId } = params;
    if (relationList.length) {
        const defaultList = createDefaultMegerFolderList(colleagueAccountId, relationList);
        const list = [];
        relationList.forEach(relation => {
            const email = relation.email;
            let item;
            if (data[email]) {
                item = data[email];
            }
            else if (relation.accountId === colleagueAccountId) {
                item = data['main'];
            }
            if (item) {
                const accountRelationEmail = formatSubordinateRelationEmail2TreeData(colleagueAccountId, relation);
                const { mailBoxModel, ids: folderIds } = item;
                accountRelationEmail.children = formatSubordinateFolder2TreeData({
                    list: mailBoxModel,
                    ids: folderIds,
                    relationEmailList: [relation],
                    colleagueAccountId,
                    accountId: relation.accountId,
                });
                list.push(accountRelationEmail);
            }
        });
        const colleagueItem = colleague;
        if (colleagueItem.originId === colleagueAccountId) {
            if (list.length === 0) {
                colleagueItem.isLeaf = true;
            }
            else if (list.length === 1 && list[0].originId === colleagueAccountId) {
                colleagueItem.children = list[0].children;
            }
            else {
                colleagueItem.children = [...defaultList, ...list];
            }
        }
        else {
        }
        return ((_a = colleagueItem.children) === null || _a === void 0 ? void 0 : _a.length) ? [...colleagueItem.children] : [];
    }
    return ((_b = colleague.children) === null || _b === void 0 ? void 0 : _b.length) ? [...colleague.children] : [];
};
export const formatSubordinateRelationEmail2TreeData = (colleagueAccountId, relationAccount) => {
    return {
        title: relationAccount.name || relationAccount.email,
        key: `account${colleagueAccountId}@@${relationAccount.accountId}`,
        isLeaf: false,
        nodeType: 'account',
        nodeData: relationAccount,
        colleagueAccountId,
        originId: relationAccount.accountId,
    };
};
export const formatSubordinateContact2TreeData = (item) => {
    const { id, nickName } = item;
    return {
        title: nickName,
        key: 'colleague@@' + id,
        isLeaf: true,
        nodeType: 'subordinate',
        nodeData: item,
        colleagueAccountId: id,
        originId: id,
    };
};
export const createDefaultMegerFolderList = (colleagueAccountId, relationEmailList) => {
    var _a;
    const allFolders = [
        {
            key: `mutiAccountFolder${colleagueAccountId}@@receive`,
            title: '全部收件箱',
            isLeaf: true,
            nodeType: 'mutiAccountFolder',
            relationEmailList,
            colleagueAccountId,
            ids: [FLOLDER.DEFAULT],
            originId: 'RECEIVE',
        },
        {
            key: `mutiAccountFolder${colleagueAccountId}@@send`,
            title: '全部已发送',
            isLeaf: true,
            nodeType: 'mutiAccountFolder',
            relationEmailList,
            ids: [FLOLDER.SENT],
            colleagueAccountId,
            originId: 'SEND',
        },
    ];
    if (process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) {
        const customerUnFollowfolder = {
            key: `mutiAccountFolder${colleagueAccountId}@@customer_unfollow`,
            title: '全部有档待跟进',
            isLeaf: true,
            nodeType: 'mutiAccountFolder',
            relationEmailList,
            ids: [FLOLDER.CUSTOMER_UNFOLLOW],
            colleagueAccountId,
            originId: 'CUSTOMER_UNFOLLOW',
            nodeData: {
                entry: {
                    mailBoxTotal: 0,
                },
            },
        };
        const unFollowFolder = {
            key: `mutiAccountFolder${colleagueAccountId}@@unfollow`,
            title: '全部无档待跟进',
            isLeaf: true,
            nodeType: 'mutiAccountFolder',
            relationEmailList,
            ids: [FLOLDER.UNFOLLOW],
            colleagueAccountId,
            originId: 'UNFOLLOW',
            nodeData: {
                entry: {
                    mailBoxTotal: 0,
                },
            },
        };
        allFolders.push(customerUnFollowfolder);
        allFolders.push(unFollowFolder);
    }
    return allFolders;
};
export const createAllSuborbinateFolderList = () => {
    if (process.env.BUILD_ISEDM) {
        return [
            {
                key: `allSubordinateFolder@@ALL_MAIL`,
                title: getIn18Text(['QUANBU', 'SHOUJIANXIANG']),
                isLeaf: true,
                nodeType: 'allSubordinateFolder',
                colleagueAccountId: 'allColleague',
                ids: [],
                originId: 'ALL_MAIL',
            },
            {
                key: `allSubordinateFolder@@${FLOLDER.EDM_REPLY}`,
                title: getIn18Text('YINGXIAOQIANKHF'),
                isLeaf: true,
                nodeType: 'allSubordinateFolder',
                colleagueAccountId: 'allColleague',
                ids: [FLOLDER.EDM_REPLY],
                originId: 'EDM_REPLY',
            },
            {
                key: `allSubordinateFolder@@${FLOLDER.EDM_OTHER_REPLY}`,
                title: getIn18Text('YINGXIAOQITHF'),
                isLeaf: true,
                nodeType: 'allSubordinateFolder',
                colleagueAccountId: 'allColleague',
                ids: [FLOLDER.EDM_OTHER_REPLY],
                originId: 'EDM_OTHER_REPLY',
            },
            {
                key: `allSubordinateFolder@@${FLOLDER.CUSTOMER_UNFOLLOW}`,
                title: getIn18Text('YOUDANGDAIGJ'),
                isLeaf: true,
                nodeType: 'allSubordinateFolder',
                colleagueAccountId: 'allColleague',
                ids: [FLOLDER.CUSTOMER_UNFOLLOW],
                originId: 'CUSTOMER_UNFOLLOW',
            },
            {
                key: `allSubordinateFolder@@${FLOLDER.UNFOLLOW}`,
                title: getIn18Text('WUDANGDAIGJ'),
                isLeaf: true,
                nodeType: 'allSubordinateFolder',
                colleagueAccountId: 'allColleague',
                ids: [FLOLDER.UNFOLLOW],
                originId: 'UNFOLLOW',
            },
        ];
    }
    return [];
};
